// extracted by mini-css-extract-plugin
module.exports = {"importCitations":"citation-import_importCitations__W4FtX"};